import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { USER_URL } from '../environments/environment';
import { ResponseProductFilters } from '../types/ResponseProductFilters';
import { PagedResponse } from '../types/PagedResponse';
import { Product } from '../types/Product';
import { User } from '@auth0/auth0-angular';

export interface UserProfile {
    title?: string;

    phone?: string;
}

export interface UserProfileSummary {
    id: string;
    fullName: string;
    email: string;
}

export interface UserRelationships {
    manager?: UserProfileSummary;
    directReports: UserProfileSummary[];
}

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private apiUrl = USER_URL;

    constructor(private http: HttpClient) { }

    public getMyRelationships(): Observable<UserRelationships> {
        return this.http.get<UserRelationships>(`${this.apiUrl}/my-relationships`);
    }

    public getProfile(): Observable<UserProfile> {
        return this.http.get<UserProfile>(`${this.apiUrl}/profile`);
    }

    public updateProfile(profile: UserProfile): Observable<Object> {
        return this.http.put(`${this.apiUrl}/profile`, profile);
    }
}